export default "__VITE_ASSET__hhyrLdzq__"